import React from "react";
import { CampaignMember } from "./companyTypes";
import { AccountListItem, Engagement, Penetration } from "./accounts";
import {
  ButtonsColorType,
  KeyRoles,
  PermissionRoles,
  RolesActionTag,
  RolesPriorityTag,
  RoleStatus,
  TierType,
} from "./enums";
import { RoleMembers } from "./apiTypes";

export type IconProps = {
  width?: string;
  height?: string;
  color?: string;
  secondColor?: string;
  opacity?: string;
  rotate?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
};

export const accountsTabs: { [key: string]: string } = {
  rate: "penetration_score",
  score: "total_engagement_score",
};

export type DropdownNestedItem = {
  name: string;
  nestedItems: Array<{ name: string; isAdded: boolean; parent: string }>;
  selected?: boolean;
  isAdded: boolean;
};

export const NO_PERSONA_MATCH_ID = "no_persona_match";
export const NO_PERSONA_MATCH_LABEL = "No Persona";

export const mockAccountsList: AccountListItem[] = [
  {
    id: "1",
    index: 1,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: true,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
  {
    id: "2",
    index: 2,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: false,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
  {
    id: "3",
    index: 3,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: false,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
];

export const mockEngagementScore: Engagement[] = [
  {
    index: 1,
    id: "1",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 2,
    id: "2",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 3,
    id: "3",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
];

export const mockPenetrationRate: Penetration[] = [
  {
    index: 1,
    id: "1",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 2,
    id: "2",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 3,
    id: "3",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
];

export const mockCompanyMembers: CampaignMember[] = [
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "1",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "user_crm",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "2",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "External data",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "3",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "user_crm",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
];

export const keyRolesItems: Record<KeyRoles, { [key: string]: string }> = {
  [KeyRoles.other_stakeholder]: {
    title: "Other Stakeholder",
    color: "#585858",
    backgroundColor: "#5858580D",
    tooltip:
      "Does not fit any defined buying committee role. Takes no part in the purchase decis" +
      "ion and does not influence it.",
    bubbleColor: "#9B9B9B",
    priority: RolesPriorityTag.late,
    actionTag: RolesActionTag.first,
  },
  [KeyRoles.budget_owner]: {
    title: "Budget Owner",
    color: "#2E72A2",
    backgroundColor: "#3E9EE226",
    tooltip:
      "Controls the budget allocated for purchasing the offering. Reviews and authorizes purchasing decisions" +
      " and transactions to ensure compliance, accuracy, and alignment with economic benefits. Has financial" +
      " decision-making authority.",
    bubbleColor: "#82AAC7",
    priority: RolesPriorityTag.late,
    actionTag: RolesActionTag.first,
  },
  [KeyRoles.technical_evaluator]: {
    title: "Technical Evaluator",
    color: "#5D8F27",
    backgroundColor: "#6AE23E26",
    tooltip:
      "Provides technical expertise in specifications, feasibility, integration, and compliance during the" +
      " purchase evaluation and implementation stages. Validates that the product works well and fits the" +
      " existing stack.",
    bubbleColor: "#9EBC7D",
    priority: RolesPriorityTag.mid,
    actionTag: RolesActionTag.second,
  },
  [KeyRoles.subject_matter_expert]: {
    title: "Subject Matter Expert",
    color: "#288C8C",
    backgroundColor: "#28969626",
    tooltip:
      "Owns deep domain expertise relevant to the product's field. Judges fit and feasibility from specialist" +
      " knowledge that others lack, and influences the decision through that expertise.",
    bubbleColor: "#7EBABA",
    priority: RolesPriorityTag.all,
    actionTag: RolesActionTag.complete,
  },
  [KeyRoles.final_decision_maker]: {
    title: "Final Decision Maker",
    color: "#B9453A",
    backgroundColor: "#E24C3E26",
    tooltip:
      "Holds the authority to approve or reject the purchase. Assesses the recommendations made by other" +
      " committee members and makes the final purchase decision. Has final authority on the decision, ensuring" +
      " it aligns with company goals.",
    bubbleColor: "#E79B66",
    priority: RolesPriorityTag.late,
    actionTag: RolesActionTag.first,
  },
  [KeyRoles.procurement_legal]: {
    title: "Procurement & Legal",
    color: "#9A3FC1",
    backgroundColor: "#F5ECF9",
    tooltip:
      "Handles procurement and the legal side of the purchase: vendor negotiations, contract terms," +
      " and supplier risk. Reviews contracts and data processing agreements against legal and regulatory" +
      " standards, and manages contract and compliance risk.",
    bubbleColor: "#C28CDA",
    priority: RolesPriorityTag.late,
    actionTag: RolesActionTag.complete,
  },
  [KeyRoles.security_compliance]: {
    title: "Security & Compliance",
    color: "#908D2D",
    backgroundColor: "#F4F4EA",
    tooltip:
      "Reviews the software against the company's security and data-handling requirements. Examines the vendor's " +
      "security standards, data protection practices, and compliance with internal policies.",
    bubbleColor: "#908D2D",
    priority: RolesPriorityTag.mid,
    actionTag: RolesActionTag.first,
  },
};

export const permissionRolesItems: Record<
  PermissionRoles,
  { [key: string]: string }
> = {
  [PermissionRoles.admin]: {
    title: "Admin",
    color: "#185454",
    backgroundColor: "#D4E8E8",
    tooltip: "Admin",
    borderColor: "#A9D1D1",
  },
  [PermissionRoles.client]: {
    title: "Client",
    color: "#385617",
    backgroundColor: "#DFE9D4",
    tooltip: "Client",
    borderColor: "#BED2A9",
  },
  [PermissionRoles.sales]: {
    title: "Sales",
    color: "#56551B",
    backgroundColor: "#E9E8D5",
    tooltip: "Sales",
    borderColor: "#D3D1AB",
  },
  [PermissionRoles.agency_team]: {
    title: "Agency Team",
    color: "#14597E",
    backgroundColor: "#D3EAF6",
    tooltip: "Agency Team",
    borderColor: "#A6D4ED",
  },
  [PermissionRoles.cs]: {
    title: "CS",
    color: "#185454",
    backgroundColor: "#D4E8E8",
    tooltip: "CS",
    borderColor: "#A9D1D1",
  },
  [PermissionRoles.cm]: {
    title: "CM",
    color: "#62381D",
    backgroundColor: "#EDDFD6",
    tooltip: "CM",
    borderColor: "#DABFAC",
  },
  [PermissionRoles.gtm]: {
    title: "GTM",
    color: "#621D49",
    backgroundColor: "#EDD6E4",
    tooltip: "GTM",
    borderColor: "#DAACCA",
  },
  [PermissionRoles.deal_desk]: {
    title: "Deal Desk",
    color: "#813500",
    backgroundColor: "#F7DECC",
    tooltip: "Deal Desk",
    borderColor: "#EFBC99",
  },
  [PermissionRoles.list_gen]: {
    title: "List Gen",
    color: "#5C2674",
    backgroundColor: "#EBD9F3",
    tooltip: "List Gen",
    borderColor: "#D7B2E6",
  },
};

export type TableColumnType = {
  key: string;
  minWidth: string;
  maxWidth: string;
  label: string;
  bgColor?: string;
  padding?: string;
  textAlign: "left" | "center" | "right";
};

export const buttonColorMapper: Record<
  ButtonsColorType,
  { textColor: string; borderColor: string; customGradientColor: string }
> = {
  [ButtonsColorType.gradient]: {
    textColor: "#FFFFFF",
    borderColor: "#F16300",
    customGradientColor: "#FE8836",
  },
  [ButtonsColorType.blue]: {
    textColor: "#1C3C6C",
    borderColor: "#1C3C6C",
    customGradientColor: "#1C3C6C",
  },
  [ButtonsColorType.dark_orange]: {
    textColor: "#CB6D2B",
    borderColor: "#FE8836",
    customGradientColor: "",
  },
  [ButtonsColorType.blue_white]: {
    textColor: "#FFFFFF",
    borderColor: "#1C3C6C",
    customGradientColor: "#1C3C6C",
  },
  [ButtonsColorType.grey]: {
    textColor: "#585858",
    borderColor: "#EEEEEE",
    customGradientColor: "#EEEEEE",
  },
  [ButtonsColorType.red_white]: {
    textColor: "#FFFFFF",
    borderColor: "#C0392B",
    customGradientColor: "#C0392B",
  },
  [ButtonsColorType.red]: {
    textColor: "#CF3E00",
    borderColor: "transparent",
    customGradientColor: "transparent",
  },
};

export const TierMapper: Record<
  TierType,
  { label: string; title: string; color: string }
> = {
  [TierType.high]: {
    label: "Tier 1",
    title: "High Priority",
    color: "#FE8836",
  },
  [TierType.medium]: {
    label: "Tier 2",
    title: "Medium Priority",
    color: "#1A76A8",
  },
  [TierType.low]: { label: "Tier 3", title: "Low Priority", color: "#4DA9DB" },
};

export const priorityActionTags: Record<
  RolesPriorityTag & RolesActionTag,
  { label: string; color: string; borderColor: string; backgroundColor: string }
> = {
  [RolesPriorityTag.early]: {
    label: "Early",
    color: "#19551F",
    borderColor: "#AAD2AE",
    backgroundColor: "#EAF4EB",
  },
  [RolesPriorityTag.mid]: {
    label: "Mid",
    color: "#255B82",
    borderColor: "#D5E3EC",
    backgroundColor: "#EAF1F6",
  },
  [RolesPriorityTag.late]: {
    label: "Late",
    color: "#5C2674",
    borderColor: "#D7B2E6",
    backgroundColor: "#F5ECF9",
  },
  [RolesPriorityTag.all]: {
    label: "All stages",
    color: "#353535",
    borderColor: "#BCBCBC",
    backgroundColor: "#EEEEEE",
  },
  [RolesActionTag.first]: {
    label: "Find first",
    color: "#FFFFFF",
    borderColor: "#112441",
    backgroundColor: "#112441",
  },
  [RolesActionTag.second]: {
    label: "Find second",
    color: "#FFFFFF",
    borderColor: "#1C3C6C",
    backgroundColor: "#1C3C6C",
  },
  [RolesActionTag.complete]: {
    label: "Complete picture",
    color: "#FFFFFF",
    borderColor: "#585858",
    backgroundColor: "#585858",
  },
};
